const HOST = "https://seerah-be.valortutors.com"
// const HOST = "http://localhost:4000"

export { HOST }